import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  constructor() { }

  private isInViewMode = new BehaviorSubject<boolean>(false);
  private isShowSavedViews = new BehaviorSubject<boolean>(false);
  private savedViews = new BehaviorSubject<Array<any>>([]);
  private savedView = new BehaviorSubject<any>({});
  private deletedSavedView = new BehaviorSubject<any>({});
  private spinnerLoader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	data$: Observable<any> = this.spinnerLoader.asObservable();

  // Observe
  isInViewMode$ = this.isInViewMode.asObservable();
  isShowSavedViews$ = this.isShowSavedViews.asObservable();
  savedViews$ = this.savedViews.asObservable();
  savedView$ = this.savedView.asObservable();
  deletedSavedView$ = this.deletedSavedView.asObservable();

  // Update
  updateIsInViewMode(isInViewMode: boolean) {
    this.isInViewMode.next(isInViewMode);
  }

  updateIsShowSavedViews(isShowSavedViews: boolean) {
    this.isShowSavedViews.next(isShowSavedViews);
  }

  setSavedViews(savedViews: Array<any>) {
    this.savedViews.next(savedViews);
  }

  loadSavedView(savedView: any) {
    this.savedView.next(savedView);
  }

  deleteSavedView(savedView: any) {
    this.deletedSavedView.next(savedView);
  }


	setSpinner(isLoading: boolean): void {

		if (!isLoading) setTimeout(() => this.spinnerLoader.next(isLoading), 1000);
		else this.spinnerLoader.next(isLoading);
	}

	spinnerLoading(): Observable<boolean> {
		return this.data$;
	}
}
